module.exports = __webpack_public_path__ + "static/img/index_item05.285fbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_item05.png
// module id = TwwL
// module chunks = 0